export const CALENDAR_WIDTH = 280;
export const CALENDAR_WITH_WEEKS_WIDTH = 320;
